<div class="u-flex-column">
  <div class="col">
    <section class="u-flex-column">
      <div class="col-12">
        <mat-card
          appearance="outlined"
          class="stepper-card">
          <mat-card-header>
            <mat-card-title>
              {{ localizationConstants.SERVICE_REQUEST_STEP_CONTACT_TITLE | translate }}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <table class="o-list-table o-list-table--compact u-w--full">
              <tr class="o-list-table__item">
                <td
                  scope="row"
                  class="o-list-table__title">
                  {{ localizationConstants.SERVICE_REQUEST_STEP_CONTACT_NAME | translate }}
                </td>
                <td class="o-list-table__description">
                  <input
                    #fullName="ngModel"
                    name="fullName"
                    [(ngModel)]="ra.fromContact"
                    type="text"
                    required
                    class="c-input c-input--gamma" />
                  <app-form-field-error [control]="fullName.control"></app-form-field-error>
                </td>
              </tr>
              <tr class="o-list-table__item">
                <td
                  scope="row"
                  class="o-list-table__title">
                  {{ localizationConstants.SERVICE_REQUEST_CONTACT_EMAIL | translate }}
                </td>
                <td class="o-list-table__description">
                  <input
                    #email="ngModel"
                    name="email"
                    [(ngModel)]="ra.customerEmail"
                    type="text"
                    required
                    class="c-input c-input--gamma" />
                  <app-form-field-error [control]="email.control"></app-form-field-error>
                </td>
              </tr>
              <tr class="o-list-table__item">
                <td
                  scope="row"
                  class="o-list-table__title">
                  {{ localizationConstants.SERVICE_REQUEST_CONTACT_PHONE | translate }}
                </td>
                <td class="o-list-table__description">
                  <input
                    name="phoneNumber"
                    [formControl]="phoneNumberControl"
                    required
                    type="tel"
                    class="c-input c-input--gamma" />
                  <app-form-field-error [control]="phoneNumberControl"></app-form-field-error>
                </td>
              </tr>
            </table>
          </mat-card-content>
        </mat-card>
      </div>
      <mat-divider></mat-divider>
      <div class="col-12">
        <mat-card
          appearance="outlined"
          class="stepper-card">
          <mat-card-header>
            <mat-card-title>
              {{ localizationConstants.SERVICE_REQUEST_STEP_DOCUMENTS | translate }}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <drag-n-drop (file)="attachDocument.emit($event)"></drag-n-drop>
          </mat-card-content>
        </mat-card>
      </div>
      <mat-divider></mat-divider>
      <div class="col-12">
        <mat-card
          appearance="outlined"
          class="stepper-card">
          <mat-card-header>
            <mat-card-title>
              {{ localizationConstants.SERVICE_REQUEST_STEP_PURCHASE_ORDER_TITLE | translate }}
            </mat-card-title>
            <mat-card-subtitle>
              <span
                *ngIf="poRequired"
                class="c-postfix">
                ({{ localizationConstants.LABEL_REQUIRED | translate }})
              </span>
            </mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <div class="details-step-po-request-section">
              <input
                name="poNumber"
                [(ngModel)]="ra.poNumber"
                type="text"
                class="c-input c-input--gamma details-step-po-input"
                [class.is-invalid]="showValidationErrors() && !ra.poNumber && poRequired"
                [required]="poRequired" />
            </div>
            <app-form-field-error
              [control]="step2form.controls[formKeys.poNumber]"></app-form-field-error>
          </mat-card-content>
        </mat-card>
      </div>

      <mat-divider></mat-divider>

      <div class="col-12">
        <mat-card
          *ngIf="!ra.isShipmentRequested"
          appearance="outlined"
          class="stepper-card">
          <mat-card-header>
            <mat-card-title>
              {{ localizationConstants.SERVICE_REQUEST_STEP_TRACKING_NUMBER_TITLE | translate }}
            </mat-card-title>
            <mat-card-subtitle>
              <span
                *ngIf="poRequired"
                class="c-postfix">
                ({{ localizationConstants.LABEL_REQUIRED | translate }})
              </span>
            </mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <input
              name="trackingNumber"
              [(ngModel)]="ra.trackingNumber"
              type="text"
              class="c-input c-input--gamma details-step-track-number-input"
              [class.is-invalid]="showValidationErrors() && !ra.poNumber && poRequired"
              [required]="poRequired" />
            <span
              *ngIf="!!step2form.controls[formKeys.trackingNumber]?.errors?.maxlength"
              class="c-form-alert">
              {{ localizationConstants.VALIDATION_MAX_LENGTH_MESSAGE | translate: { value: 20 } }}
            </span>
          </mat-card-content>
        </mat-card>

        <mat-card
          *ngIf="ra.isShipmentRequested"
          appearance="outlined"
          class="stepper-card">
          <mat-card-content>
            <app-shipping-packages-request-form
              [formArray]="shippingParcelsFormArray"
              [customerSettings]="customerSettings"
              (addPackageEvent)="addPackage()"
              (removePackageEvent)="removePackage($event)"
              (copyPackageEvent)="copyPackage($event)">
            </app-shipping-packages-request-form>

            <div class="u-mt--medium">
              <label class="c-label c-info-box">
                <mat-icon
                  svgIcon="information"
                  class="icon-size-xs"></mat-icon>
                <span class="u-ml--small">{{
                  localizationConstants.SERVICE_REQUEST_STEP_SHIPPING_PACKAGES_MAX_DIMENSIONS_NOTE
                    | translate
                }}</span>
              </label>
            </div>

            <div class="u-mt--medium">
              <label class="c-label c-warning-box">
                <mat-icon
                  svgIcon="warning"
                  class="icon-size-xxs"></mat-icon>
                <span>{{
                  localizationConstants.SERVICE_REQUEST_STEP_SHIPPING_PACKAGES_NO_DANGEROUS_GOODS_ALLOWED
                    | translate
                }}</span>
              </label>
            </div>

            <div class="u-mt--large">
              <h3>
                {{ localizationConstants.SERVICE_REQUEST_SHIPPING_PACKAGES_SUMMARY | translate }}
              </h3>
            </div>

            <div class="u-mt--large">
              <label
                >{{
                  localizationConstants.SERVICE_REQUEST_SHIPPING_PACKAGES_TOTAL_PACKAGES | translate
                }}
                : {{ shippingParcelsFormArray?.length }}</label
              >
              <app-form-field-error [control]="totalParcelsControl"></app-form-field-error>
            </div>

            <div class="u-mt--large">
              <label for="pickupDate">
                {{
                  localizationConstants.SERVICE_REQUEST_SHIPPING_PACKAGES_PICKUP_DATE | translate
                }}
              </label>
              <datepicker-input
                class="u-relative"
                [size]="'lg'"
                [inputDate]="pickupDateControl?.value"
                [filter]="filterOutPastAndWeekends"
                (dateChange)="onPickupDateChange($event)">
              </datepicker-input>
              <div>
                <app-form-field-error [control]="pickupDateControl"></app-form-field-error>
              </div>
            </div>

            <!-- TODO: Uncomment time inputs when time issue is resolved on Montova side -->
            <!-- <div class="u-mt--medium">
              <label>
                {{
                  localizationConstants.SERVICE_REQUEST_SHIPPING_PACKAGES_BUSINESS_HOURS | translate
                }}
              </label>
            </div>

            <div class="flex gap-lg">
              <div>
                <input
                  readonly
                  name="businessStart"
                  class="c-input c-input--alpha c-not-allowed"
                  [formControl]="businessStartControl"
                  type="time" />
                <div>
                  <app-form-field-error [control]="businessStartControl"></app-form-field-error>
                </div>
              </div>
              <div class="u-align-self-center">-</div>
              <div>
                <input
                  readonly
                  name="businessEnd"
                  class="c-input c-input--alpha c-not-allowed"
                  [formControl]="businessEndControl"
                  type="time" />
                <div>
                  <app-form-field-error [control]="businessEndControl"></app-form-field-error>
                </div>
              </div>
            </div> -->

            <div class="u-mt--large">
              <label for="parcelsAdditionalInfo">
                {{
                  localizationConstants.SERVICE_REQUEST_SHIPPING_PACKAGES_ADDITIONAL_INFO
                    | translate
                }}
              </label>
              <textarea
                [formControl]="parcelsAdditionalInfoControl"
                class="c-input c-input--alpha c-textarea">
              </textarea>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="col-12">
        <mat-card
          appearance="outlined"
          class="stepper-card">
          <mat-card-header>
            <mat-card-title>
              {{ localizationConstants.SERVICE_REQUEST_STEP_REMARKS | translate }}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <textarea
              #comments="ngModel"
              [(ngModel)]="ra.comments"
              (ngModelChange)="onCommentsChange()"
              name="service-request-remarks"
              class="c-input c-input--alpha c-textarea">
            </textarea>
          </mat-card-content>
        </mat-card>
      </div>
    </section>
  </div>
</div>
